<template>
    <v-container id="DetalleReporte" class="pt-5"
        style="padding-top: 80px !important; display: flex; flex-direction: column; height: 100%;">
        <!--Tabla de pendientes NPS-->
        <!--<div :class="['tabla-container', { 'tabla-expandida': !historialSeguimiento || !mostrarSeguimiento }]" class="tabla-container">-->
        <div v-if="expediente">
            <LisExpediente @dialogCloseEvent="helpDialogEmit" :exnrreporte="datosExpediente.nrreporte"
                :exsvindice="datosExpediente.svindice" :exaiclave="datosExpediente.aiclave"></LisExpediente>
        </div>
        <div :class="['tabla-container', { 'tabla-expandida': !historialSeguimiento && !mostrarSeguimiento }]"
            class="tabla-container">


            <v-card elevation="6" class="base-card-container tabla-card pa-0 mt-4">
                <v-card-title class="pa-5 pb-3 primary">
                    <p style="color: white;">Mis Pendientes NPS</p>
                </v-card-title>
                <v-col cols="12" md="3">
                    <div style="display: flex; align-items: center; gap: 10px;">
                        <label style="margin: 0; color: #555;">Todos los pendientes</label>
                        <v-switch v-model="switchci" inset @change="asignacionRC()"></v-switch>
                        <label style="margin: 0; color: #555;">Usuario</label>
                    </div>

                </v-col>
                <v-form>
                    <v-card-text>
                        <v-row justify="center">
                            <v-col cols="12">
                                <DataTable :url="urlListado" :columns="columns" :params="displayInputsRC" :order="[]"
                                    :formatterActions="formatterActions" @apiDT="apiDT = $event"></DataTable>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-form>
            </v-card>
        </div>

        <!--Card de marcar seguimiento-->
        <!--<v-container class="d-flex justify-center align-center fill-height">-->
        <v-container v-if="mostrarSeguimiento">
            <v-col cols="12" md="4">
                <v-slide-x-reverse-transition>
                    <v-card v-if="mostrarSeguimiento" elevation="6"
                        class="pa-4 base-card-container mostrar-seguimiento">
                        <v-card-title class="pa-3 primary text-white">
                            Marcar seguimiento
                        </v-card-title>
                        <div class="centered-list mb-4 mt-2">
                            <span class="txtTReporte">Reporte: {{ datosSeguimiento.nrreportei }}</span>
                        </div>
                        <v-card-text>
                            <template>
                                <v-container>
                                    <v-form ref="seguimientoForm">
                                        <div v-if="fechaInicio && timeInicio && isFStorage" class="centered-list mb-2">
                                            <v-alert outlined type="warning" prominent border="left">
                                                Se cargó <strong>fecha</strong> y <strong>hora</strong> de la
                                                <strong>última llamada realizada</strong>, verifica que sean correctos
                                            </v-alert>
                                        </div>
                                        <v-row class="mb-8" style="margin-bottom: 0px !important; margin-top: 0px;">
                                            <v-col md="6" cols="12">
                                                <span class="txtTCard">Fecha:</span>
                                                <v-dialog ref="dialogFhInicio" outlined v-model="modalFechaInicio"
                                                    persistent width="290px">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <div class="date-align-center">
                                                            <v-text-field class="pt-2" v-model="fechaInicio" label=""
                                                                outlined dense v-bind="attrs" v-on="on" readonly
                                                                :rules="rulesFecha">
                                                            </v-text-field>
                                                        </div>
                                                    </template>
                                                    <v-date-picker v-model="fechaInicio"
                                                        :min="new Date(minDateFhIni).toISOString().split('T')[0]"
                                                        :max="maxDateFhIni" locale="es" scrollable>
                                                        <v-spacer></v-spacer>
                                                        <v-btn text color="secondary"
                                                            @click="modalFechaInicio = false">Cancelar</v-btn>
                                                        <v-btn text color="primary" @click="guardarFecha()">
                                                            Aceptar
                                                        </v-btn>
                                                    </v-date-picker>
                                                </v-dialog>
                                            </v-col>
                                            <v-col md="6" cols="12">
                                                <span class="txtTCard">Hora:</span>
                                                <v-dialog ref="dialogHrIni" v-model="modalHrInicio" outlined persistent
                                                    width="290px">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field class="pt-2" v-model="timeInicio" label=""
                                                            outlined dense v-bind="attrs" v-on="on" readonly
                                                            :rules="rulesHora"></v-text-field>
                                                    </template>
                                                    <v-time-picker v-if="modalHrInicio" v-model="timeInicio"
                                                        :min="mintimeInicio" format="24hr" ampm-in-title scrollable
                                                        full-width>
                                                        <v-spacer></v-spacer>
                                                        <v-btn text color="secondary" @click="modalHrInicio = false">
                                                            Cancelar
                                                        </v-btn>
                                                        <v-btn text color="primary" @click="guardarHora()">
                                                            Aceptar
                                                        </v-btn>
                                                    </v-time-picker>
                                                </v-dialog>
                                            </v-col>
                                        </v-row>
                                        <div class="mt-4">
                                            <span class="txtTCard">Observación:</span>
                                            <v-textarea :counter="$store.state.maxLengthComentarios"
                                                :rules="rulestextarea" outlined v-model="datosSeguimiento.observaciones"
                                                required :maxlength="$store.state.maxLengthComentarios"
                                                name="input-7-4"></v-textarea>
                                        </div>
                                    </v-form>
                                </v-container>
                            </template>
                        </v-card-text>
                        <br /> <br /> <br /> <br />
                        <div class="botones">
                            <v-btn class="ma-2" @click="guardarSeguimientoNPS()" :disabled="disabledSaveGuardar"
                                color="#536DFE" style="color:white">
                                Guardar <v-icon dark right>mdi-content-save</v-icon>
                            </v-btn>
                            <v-btn class="ma-2" @click="cerrarSeguimiento" color="error"
                                :disabled="disabledSaveGuardar">
                                Cancelar <v-icon dark right>mdi-window-close</v-icon>
                            </v-btn>
                        </div>
                    </v-card>
                </v-slide-x-reverse-transition>
            </v-col>
        </v-container>



        <!--Card Historial de seguimiento-->
        <v-container v-if="historialSeguimiento">
            <v-col cols="12" md="4">
                <v-slide-x-reverse-transition>
                    <v-card v-if="historialSeguimiento" elevation="6"
                        class="base-card-container pa-4 mostrar-historial">
                        <v-card-title class="pa-3 primary text-white">
                            Historial de seguimiento
                        </v-card-title>
                        <div class="centered-list mb-4 mt-2">
                            <span class="txtTReporte">
                                Reporte: {{ historialNPS.length > 0 ? datosSeguimiento.nrreportei :
                                datosSeguimiento.nrreportei
                                }}
                                <v-btn class="ma-2" @click="active = false; cerrarHistorial()" color="red" dark>
                                    <v-icon dark>mdi-close-outline</v-icon>
                                </v-btn>
                                <br v-if="historialNPS.length === 0" />
                                <span v-if="historialNPS.length === 0">Sin seguimiento</span>

                            </span>
                        </div>
                        <v-card-text class="scrollable-content">
                            <template v-if="historialNPS.length > 0">
                                <v-container>
                                    <v-row v-for="(registro, index) in paginatedHistorial" :key="index">
                                        <v-col cols="12">
                                            <div class="mb-2">
                                                <span class="txtTCard">Fecha de seguimiento:</span>
                                                <div class="text-body-1">{{ registro.senpsfh }}</div>
                                            </div>
                                            <div class="mb-2">
                                                <span class="txtTCard">Observaciones:</span>
                                                <div class="text-body-1">{{ registro.senpsobsv }}</div>
                                            </div>
                                            <div class="mb-2">
                                                <span class="txtTCard">Usuario:</span>
                                                <div class="text-body-1">{{ registro.uslogin }}</div>
                                            </div>
                                            <div class="mb-2">
                                                <span class="txtTCard">Fecha captura:</span>
                                                <div class="text-body-1">{{ registro.senpsfhalta }}</div>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" v-if="index < paginatedHistorial.length - 1">
                                            <v-divider></v-divider>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </template>
                        </v-card-text>
                        <!-- Paginador -->
                        <!--<v-card-actions >-->
                        <div v-if="totalPages > 1" class="d-flex justify-center mt-2 sticky-pagination">
                            <v-pagination v-model="currentPage" :length="totalPages" class="justify-center"
                                color="primary">
                            </v-pagination>
                        </div>
                        <!--</v-card-actions>-->
                        <!-- Paginador -->
                    </v-card>
                </v-slide-x-reverse-transition>
            </v-col>
        </v-container>

    </v-container>

</template>
<script>
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
import DataTable from "@/components/pages/DataTableNet/DataTable";
import SerBusqueda from '@/services/Busqueda/Busqueda.service.js';
import Calidad from "@/services/Calidad/Calidad.service.js";
import LisExpediente from "@/components/pages/Calidad/components/Expediente";
export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        DataTable, LisExpediente
    },
    data() {
        return {
            data: {},
            urlListado: "Calidad/ObtenerMisPendientes",
            apiDT: null,
            Intentos: '',
            //campos de fecha
            fhSeguimiento: false,
            maxdate: null,
            mindate: null,
            modalFechaInicio: false,
            fechaInicio: '',
            timeInicio: '',
            minDateFhIni: '',
            modalHrInicio: false,
            mintimeInicio: '',
            isFStorage: false,

            //Historial
            historialNPS: [],
            historialSeguimiento: false,
            expediente: false,
            //paginador
            currentPage: 1,
            itemsPerPage: 4,
            selectedRegistro: null,

            //Filtrado 
            switchci: true,
            rc: false,


            //Panel
            mostrarSeguimiento: false,
            disabledSaveGuardar: false,
            datosExpediente:
            {
                nrreporte: '',
                svindice: '',
                aiclave: '',
            },
            datosSeguimiento: {
                Nrreportei: "",
                nrreporte: "",
                svindice: "",
                egid: "",
                fecha: "",
                hora: "",
                fechaHora: "",
                observaciones: "",
            },
            limpiarCampos() {
                this.datosSeguimiento = {
                    Nrreportei: "",
                    nrreporte: "",
                    svindice: "",
                    egid: "",
                    fecha: "",
                    hora: "",
                    fechaHora: "",
                    observaciones: "",

                };
                this.fechaInicio = "";
                this.timeInicio = "";
                this.isFStorage = false;
            },
            //reglas
            rulesHora: [
                v => !!v || 'Este campo es requerido'
            ],
            rulesFecha: [
                v => !!v || 'Este campo es requerido',
                v => {
                    if (!v) return true;
                    const selectedDate = new Date(v + 'T00:00:00');
                    return selectedDate >= this.minDateFhIni;
                },
            ],
            //rulestextarea: [v => !!v || 'Campo requerido',
            //    v => {
            //        if (v == null) {
            //            return true
            //        }
            //        else {
            //            // return 'Mínimo 12 Carácteres'

            //            if (v.length < 12) {
            //                return 'Mínimo 12 Carácteres'
            //            }
            //            else if (v.length > 400) {
            //                return 'Máximo 400 Carácteres'
            //            }
            //            else
            //                return true
            //        }
            //    },
            //],
            rulestextarea: [
                (value) => !!value || 'El campo es obligatorio',
                (value) => value.length <= this.$store.state.maxLengthComentarios || 'Máximo de caracteres excedido'
            ],
            columns: [
                { name: "Nrreportei", data: "Nrreportei", title: "Reporte", formatter: [this, "reporteForm"], },
                { name: "Aseguradora", data: "Aseguradora", title: "Aseguradora" },
                { name: "NombreAsegurado", data: "NombreAsegurado", title: "Asegurado" },
                { name: "FechaCierre", data: "FechaCierre", title: "Fecha de cierre" },
                { name: "Estatus", data: "Estatus", title: "Estatus" },
                { name: "Intentos", data: "Intentos", title: "Intentos" },
                { name: "Tipo", data: "Tipo", title: "Tipo Encuesta" },
                { name: "Asistencia", data: "Asistencia", title: "Asistencia" },
                { name: "Responsable", data: "Responsable", title: "Responsable" },
                { name: "MSeguimiento", data: "MSeguimiento", title: "Agregar seguimiento", formatter: [this, "formatearMSeguimiento"], orderable: false, },
                { name: "VReporte", data: "VReporte", title: "Historial", formatter: [this, "formatearVReporte"], orderable: false },
                { name: "ExReporte", data: "ExReporte", title: "Expediente", formatter: [this, "formatearExReporte"], orderable: false },
            ],
            displayInputsRC: {
                rc: false,
                uslogin: MetodosGenerales.ObtenerUserName(),
            },
            formatterActions: [
                { click: [this, "BuscarDetalleRep"] },
                { click: [this, "mostrarPanelSeguimiento"] },
                { click: [this, "mostrarPanelHistorial"] },
                { click: [this, "mostrarExpediente"] },
            ],
        };
    },
    computed: {
        ...mapState(["domain", "informationPage"]),

        totalPages() {
            return Math.ceil(this.historialNPS.length / this.itemsPerPage);
        },
        paginatedHistorial() {
            const start = (this.currentPage - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.historialNPS.slice(start, end);

        },
    },
    methods:
    {
        helpDialogEmit(value) {
            this.expediente = value;
        },
        reloadTable() {
            if (this.apiDT != null) {
                this.apiDT.ajax.reload(null, false);
                this.apiDT.columns.adjust().responsive.recalc();
            }
        },
        updateIntentos() {
            if (this.apiDT != null) {
                let rowIndex = null;

                // Recorremos todas las filas con el índice interno (no el visual)
                this.apiDT.rows().every(function (index) {
                    let data = this.cell(index, 0).data();
                    if (String(data) === String(this.datosSeguimiento.nrreportei)) {
                        rowIndex = index;
                        return false; // salir del bucle
                    }
                }.bind(this)); // importante para que `this` siga siendo tu componente

                console.log(rowIndex);
                if (rowIndex !== null) {
                    this.apiDT.cell(rowIndex, 5).data(this.Intentos).draw();
                }
            }
        },

        //Juntar fecha y hora
        guardarFecha() {
            if (!this.fechaInicio) {
                return
            }
            if (this.fechaInicio && new Date(this.fechaInicio) > new Date(this.minDateFhIni)) {
                this.datosSeguimiento.fecha = this.fechaInicio;
            } else {
                this.datosSeguimiento.fecha = new Date(this.fechaInicio).toISOString().substr(0, 10);
            }
            this.modalFechaInicio = false;
        },
        guardarHora() {
            if (!this.timeInicio) {
                return
            }
            if (this.timeInicio != '') {
                this.datosSeguimiento.hora = this.timeInicio;
            } else {
                console.error('La fecha de inicio no está definida');
            }
            this.modalHrInicio = false;
        },

        actualizarFechaHora() {
            if ((this.fechaInicio != '') && (this.timeInicio != '')) {

                const fecha = new Date(this.fechaInicio + 'T00:00:00');
                const hora = this.timeInicio.split(':');

                const fechaHora = new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate(), hora[0], hora[1]);

                this.datosSeguimiento.fechaHora = fechaHora.toISOString();
            }
        },

        reporteForm(datos) {
            return `<div class="ml-4"><button type="button" class="mr-1 dt-formatterAction" aria-haspopup="true" data-action="0" data-params="${datos}" aria-expanded="false"><span class='reporteindice'>${datos.Nrreporte}-${datos.Svindice}</span></button></div>`;
        },
        formatearMSeguimiento() {
            return `<div style="text-align: center; vertical-align: middle;">
                    <button type="button"
                            @click="mostrarPanelSeguimiento"
                            data-action="1"
                            class="dt-formatterAction ma-1 v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary"
                            title="Seguimiento">
                        <span class="v-btn__content">
                            <i aria-hidden="true" class="v-icon notranslate mdi mdi-clipboard-check theme--light white--text"></i>
                        </span>
                    </button>
                </div>`;
        },
        formatearVReporte() {
            return `<div style="text-align: center; vertical-align: middle;">
                    <button type="button"
                            @click="mostrarPanelHistorial"
                            data-action="2"
                            class="dt-formatterAction ma-1 v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default success"
                            title="Detalle">
                        <span class="v-btn__content">
                            <i aria-hidden="true" class="v-icon notranslate mdi mdi-book-open-page-variant theme--light white--text"></i>
                        </span>
                    </button>
                </div>`;
        },
        formatearExReporte() {
            return `<div style="text-align: center; vertical-align: middle;">
                    <button type="button"
                            @click="mostrarExpediente"
                            data-action="3"
                            class="dt-formatterAction ma-1 v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default default"
                            title="Expediente">
                        <span class="v-btn__content">
                            <i aria-hidden="true" class="v-icon notranslate mdi mdi-file-document theme--light white--text"></i>
                        </span>
                    </button>
                </div>`;
        },
        mostrarPanelSeguimiento(params, item, fila) {
            this.ObtenerUltimaLlamada(item);
            this.procesarFHMinima(item.FHMinima);
            this.mostrarSeguimiento = true;
            this.historialSeguimiento = false;
            this.expediente = false;
            this.datosSeguimiento.nrreportei = item.Nrreportei;
            this.datosSeguimiento.nrreporte = item.Nrreporte;
            this.datosSeguimiento.svindice = item.Svindice;
            this.datosSeguimiento.egid = item.egid;

        },

        mostrarPanelHistorial(params, item, fila) {
            this.historialSeguimiento = true;
            this.mostrarSeguimiento = false;
            this.expediente = false;
            this.datosSeguimiento.nrreportei = item.Nrreportei;
            this.cargarHistorial(item);

        },
        mostrarExpediente(params, item, fila) {
            this.datosExpediente.nrreporte = item.Nrreporte;
            this.datosExpediente.svindice = item.Svindice;
            this.datosExpediente.aiclave = item.aiclave;
            this.expediente = true;
            this.mostrarSeguimiento = false;
            this.historialSeguimiento = false;

            //this.cargarHistorial(item);

        },
        cerrarSeguimiento() {
            this.mostrarSeguimiento = false;
            this.limpiarCampos();
        },
        cerrarHistorial() {
            this.historialSeguimiento = false;
            this.currentPage = 1;

        },
        async BuscarDetalleRep(params, item, fila) {
            let datos, nuevo, icono, url;
            let reporte = {
                nrreporte: item.Nrreporte,
                svindice: item.Svindice,
                aiclave: item.aiclave,
                svfhconclusion: item.svfhconclusion
            };


            var ver = 0;
            let formData = new FormData();
            formData.append("nrreporte", item.Nrreporte);
            formData.append("svindice", item.Svindice);
            formData.append("uslogin", MetodosGenerales.ObtenerUserName());

            let result = await SerBusqueda.ObtenerValidacion(this, formData);
            ver = result;


            if (ver == 0) {
                let url = this.$router.resolve({ name: `${"DatosIncompletos"}` });
                window.open(url.href, '_blank');
            }
            else {
                await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
                let url = this.$router.resolve({ name: `${"Asistencias"}` });
                window.open(url.href, '_blank');
            }


        },

        async guardarSeguimientoNPS() {
            this.actualizarFechaHora();
            this.disabledSaveGuardar = true;
            this.datosSeguimiento.observaciones = this.datosSeguimiento.observaciones.trim();
            this.$refs.seguimientoForm.validate();
            if (this.$refs.seguimientoForm.validate()) {
                this.$swal({
                    position: 'center',
                    title: 'Guardando seguimiento...',
                    text: 'Espere un momento por favor',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    }
                });
                await Calidad.guardarSeguimientoNPS(this).then(response => {
                    this.$swal.close();
                    if (response.data[0].Intentos) {
                        this.Intentos = response.data[0].Intentos;
                        this.$swal({
                            position: 'center',
                            icon: 'success',
                            title: 'Éxito',
                            text: 'El seguimiento se realizó correctamente',
                            allowOutsideClick: false,
                            timer: 5000,
                        }).then(() => {
                            this.reloadTable();
                            this.cerrarSeguimiento();
                            this.limpiarCampos();;
                        });
                    }
                    else {
                        this.$swal({
                            position: 'center',
                            icon: 'warning',
                            title: 'Advertencia',
                            text: 'El seguimiento no se ha realizado correctamente',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            timer: 5000,
                        }).then(async () => {
                            this.disabledSaveGuardar = false;
                            this.cerrarSeguimiento = false;
                        });
                    }
                }).finally(() => {
                    this.disabledSaveGuardar = false;
                });
            } else {
                this.disabledSaveGuardar = false;
            }
        },
        async cargarHistorial(item) {
            this.currentPage = 1;
            const response = await Calidad.ObtenerHistorialSegNPS(item);
            if (response && response.data) {
                this.historialNPS = response.data;
            }

        },

        //Ultimollamada
        async ObtenerUltimaLlamada(item) {
            try {
                const response = await Calidad.ObtenerUltimaLlamada(item);
                const UltLlamada = response.data[0]?.UltLlamada;
                if (UltLlamada && !isNaN(new Date(UltLlamada).getTime())) {
                    this.procesarFecha(UltLlamada);
                } else {
                    this.fechaInicio = '';
                    this.timeInicio = '';
                    this.isFStorage = false;
                }
            } catch (error) {
                console.error('Error al obtener la última llamada:', error);
            }
        },
        procesarFecha(UltLLamada) {
            if (UltLLamada) {
                const [fecha, hora] = UltLLamada.split("T");
                this.fechaInicio = fecha;
                this.timeInicio = hora.split(".")[0].slice(0, 5);
                this.isFStorage = true;
            }
        },
        procesarFHMinima(FHMinima) {
            if (FHMinima) {
                const [fecha] = FHMinima.split("T");
                //this.mintimeInicio = hora.split(":").slice(0, 2).join(":");
                this.minDateFhIni = new Date(fecha + 'T00:00:00');
            }
        },

        //Filtro responsable calidad
        async asignacionRC() {
            this.showcargando = true;
            this.displayInputsRC = {
                rc: this.switchci,
                /*uslogin: MetodosGenerales.ObtenerUserName(),*/
                uslogin: this.switchci ? MetodosGenerales.ObtenerUserName() : null,

            };
            this.cerrarSeguimiento();
            this.cerrarHistorial();
        },
    },

    async mounted() {
        await Calidad.obtenerFechaActual(this).then(response => {
            this.maxDateFhIni = response[0].today;
        });

        this.displayInputsRC = {
            rc: false,
            uslogin: MetodosGenerales.ObtenerUserName(),
        };
        this.asignacionRC();
    },

    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", "12").then((response) => {
            if (response.data.length == 0) {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                return
            }
        });
        this.historialSeguimiento = false;
        /*Calidad.ObtenerMisPendientes(this);*/
        this.asignacionRC();
    },

}
</script>
<style>
.reporteindice {
    color: var(--v-anchor-base);
}

.mostrar-seguimiento {
    position: fixed !important;
    top: 80px;
    right: 0;
    width: 90%;
    max-width: 550px !important;
    height: 90vh;
    max-height: 100vh;
    overflow: hidden;
    transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out !important;
    z-index: 10;
}

.mostrar-historial {
    position: fixed !important;
    top: 80px;
    right: 0;
    width: 90%;
    max-width: 550px !important;
    height: 90vh;
    max-height: 100vh;
    overflow: hidden;
    transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out !important;
    z-index: 10;
}

/* Tabla principal con card visible */
.tabla-container {
    flex: 1 1 auto !important;
    max-width: calc(100% - 550px) !important;
    transition: max-width 0.3s ease-in-out !important;
    width: 100%;
    height: 100vh;
}

/* Tabla principal expandida sin card */
.tabla-expandida {
    max-width: 100% !important;
    flex: 1 1 100% !important;
    height: 100vh;
}

.tabla-container table {
    width: 100%;
    /*La tabla ocupará todo el ancho disponible */
    table-layout: fixed;
    /*Establece un layout que haga que las celdas se ajusten */
}

@media (max-width: 768px) {
    .mostrar-seguimiento {
        position: fixed !important;
        width: 95%;
        height: 90vh;
        max-height: 90vh;
    }

    .mostrar-historial {
        position: fixed !important;
        width: 95%;
        max-width: 95% !important;
        height: 85vh;
        max-height: 90vh;
    }

    .tabla-container {
        flex: unset !important;
        max-width: 100% !important;
        width: auto !important;
        height: auto !important;
        transition: none !important;
    }

    textarea {
        touch-action: auto !important;
        user-select: all !important;
    }
}

.scrollable-content {
    max-height: calc(100% - 210px);
    overflow-y: auto;
    padding-right: 5px;
}

.txtTReporte {
    font-size: 20px !important;
    font-weight: 600 !important;
}

.txtTCard {
    font-weight: 900 !important;
}

.centered-list {
    display: flex;
    justify-content: center;
}

.botones {
    position: sticky;
    bottom: 0;
    display: flex;
    justify-content: center;
}

.sticky-pagination {
    position: sticky;
    padding-top: 60px !important;
    bottom: 0;
}
</style>
